var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12C2.25 6.48 6.73 2 12.25 2C17.77 2 22.25 6.48 22.25 12C22.25 17.52 17.77 22 12.25 22C6.73 22 2.25 17.52 2.25 12ZM20.4798 9.48444L14.5173 9.29371L12.1871 3.4805L9.8568 9.302L4.41082 9.48444L5.90711 10.5376L10.7773 10.5459L12.1871 6.88052L13.6051 10.5542L17.2373 10.5459L14.4841 12.9342L15.3134 16.4835L12.1871 14.5928L9.06899 16.4752L9.8568 13.5718L8.61744 12.8934L7.06215 19.2367L12.1871 16.1435L17.312 19.2367L15.9603 13.4069L20.4798 9.48444Z",
    fill: "#11ADF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarActive);
export default __webpack_public_path__ + "static/media/StarActive.eeadad0c79b30d54e1cb67cd9f148aba.svg";
export { ForwardRef as ReactComponent };